/* NW – Galerie, Varianten, Mengenangebote, Sticky-Bar */
(function () {
  function money(cents, cur) {
    try { var o = { style: 'currency', currency: cur }; if (cents % 100 === 0) { o.minimumFractionDigits = 0; o.maximumFractionDigits = 0; } return new Intl.NumberFormat('de-DE', o).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' ' + cur; }
  }

  document.querySelectorAll('[data-nw-product]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-nw-json]').textContent);
    var cur = root.dataset.currency || 'EUR';
    var idInput = root.querySelector('[name="id"]');
    var qtyInput = root.querySelector('[name="quantity"]');
    var priceNow = root.querySelector('[data-nw-price]');
    var priceWas = root.querySelector('[data-nw-was]');
    var atc = root.querySelector('[data-nw-atc]');
    var mainImg = root.querySelector('[data-nw-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-nw-thumb]'));
    var idx = 0;

    /* Galerie */
    function show(i) {
      if (!thumbs.length) return;
      idx = (i + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      mainImg.src = t.dataset.src;
      mainImg.alt = t.dataset.alt || '';
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      t.classList.add('is-active');
      t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    var prev = root.querySelector('[data-nw-prev]'), next = root.querySelector('[data-nw-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    /* Varianten */
    var selected = (data.variants.find(function (v) { return v.id == idInput.value; }) || data.variants[0]).options.slice();
    function currentVariant() {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
    }
    function refresh() {
      var v = currentVariant();
      if (!v) { atc.disabled = true; atc.textContent = root.dataset.unavailable; return; }
      idInput.value = v.id;
      priceNow.textContent = money(v.price, cur);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceWas.textContent = money(v.compare_at_price, cur); priceWas.hidden = false;
      } else { priceWas.hidden = true; }
      atc.disabled = !v.available;
      atc.textContent = v.available ? root.dataset.addLabel : root.dataset.soldout;
      if (v.featured_media_id) {
        var tIdx = thumbs.findIndex(function (b) { return b.dataset.mediaId == v.featured_media_id; });
        if (tIdx > -1) show(tIdx);
      }
      updateOffers(v);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-nw-opt]').forEach(function (group) {
      var pos = +group.dataset.nwOpt;
      group.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selected[pos] = btn.dataset.value;
          refresh();
        });
      });
    });

    /* Mengenangebote (Rabatt muss im Admin als automatischer Rabatt angelegt sein!) */
    var offers = Array.prototype.slice.call(root.querySelectorAll('[data-nw-offer]'));
    function updateOffers(v) {
      offers.forEach(function (o) {
        var q = +o.dataset.qty, d = +o.dataset.discount || 0;
        var full = v.price * q, net = full - d * 100;
        o.querySelector('[data-nw-offer-price]').textContent = money(net, cur);
        var s = o.querySelector('[data-nw-offer-was]');
        if (s) { s.textContent = d > 0 ? money(full, cur) : ''; }
        var sv = o.querySelector('.nw-offer__save'); if (sv) { sv.textContent = 'Du sparst ' + money(d * 100, cur); }
      });
    }
    offers.forEach(function (o) {
      o.addEventListener('change', function () {
        offers.forEach(function (x) { x.classList.remove('is-active'); });
        o.classList.add('is-active');
        qtyInput.value = o.dataset.qty;
      });
    });

    /* Sticky-Bar */
    var sticky = document.querySelector('[data-nw-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(atc);
      sticky.querySelector('button').addEventListener('click', function () {
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    refresh();
  });
})();
